import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { AuthState } from './types';

const authSelector = (state: StoreState): AuthState | undefined => state?.auth;

export const getAuthLoading = createSelector(
  authSelector,
  (auth) => auth?.loading
);
export const getAuthError = createSelector(
  authSelector,
  (auth) => auth?.error
);
export const getAuthErrorCode = createSelector(
  authSelector,
  (auth) => auth?.errorCode
);

export const getAuthUser = createSelector(authSelector, (auth) => auth?.user);

export const getAuthMfaResponse = createSelector(
  authSelector,
  (auth) => auth?.mfaResponse
);

export const getAuthUserLicence = createSelector(
  authSelector,
  (auth) => auth?.userLicence
);

export const getThirdPartySSO = createSelector(
  authSelector,
  (auth) => auth?.thirdPartySSO
);
